import axios from "axios";

export const getUsersByRole = async (role) => {
    try {
        const response=await axios.get(
            `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/users-by-role/${role}`);
        return response.data
    } catch (error) {
        console.log(error)
    }
}

export async function fetchProductionReps(instanceUniqueId) {
    const url = `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/byinstanceUniqueId/${instanceUniqueId}?role=purchasing-rep`;
    try {
      const { data } = await axios.get(url, {
        headers: { accessToken: localStorage.getItem("accessToken") },
      });
      // API returns { listOfUsers, totalCount? }
      return Array.isArray(data?.listOfUsers) ? data.listOfUsers : [];
    } catch (e) {
        alert(e)
      console.error("fetchProductionReps failed", e);
      return [];
    }
  }

export async function fetchInstanceUsers(instanceUniqueId, options = {}) {
  const url = `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/byinstanceUniqueId/${instanceUniqueId}`;
  try {
    const { data } = await axios.get(url, {
      headers: { accessToken: localStorage.getItem("accessToken") },
      ...(Object.keys(options).length ? { params: options } : {}),
    });
    const listOfUsers = Array.isArray(data?.listOfUsers) ? data.listOfUsers : [];
    return options.withCount
      ? { listOfUsers, totalCount: Number(data?.totalCount) || 0 }
      : listOfUsers;
  } catch (e) {
    console.error("fetchInstanceUsers failed", e);
    return options.withCount ? { listOfUsers: [], totalCount: 0 } : [];
  }
}

export async function fetchFinancialConfigurationUsers(instanceUniqueId, options = {}) {
  const url = `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/byinstanceUniqueId/${instanceUniqueId}`;
  const limit = Math.min(Math.max(Number(options.limit) || 500, 1), 500);
  const headers = { accessToken: localStorage.getItem("accessToken") };

  try {
    const usersById = new Map();
    let page = 1;
    let totalCount = 0;

    do {
      const { data } = await axios.get(url, {
        headers,
        params: {
          page,
          limit,
          withCount: true,
        },
      });

      const pageUsers = Array.isArray(data?.listOfUsers) ? data.listOfUsers : [];
      totalCount = Number.isFinite(Number(data?.totalCount))
        ? Number(data.totalCount)
        : pageUsers.length;

      pageUsers.forEach((user) => {
        const id = Number(user?.id);
        if (Number.isInteger(id) && id > 0) usersById.set(id, user);
      });

      if (!pageUsers.length || usersById.size >= totalCount) break;
      page += 1;
    } while (true);

    return {
      listOfUsers: Array.from(usersById.values()),
      totalCount,
    };
  } catch (e) {
    console.error("fetchFinancialConfigurationUsers failed", e);
    return { listOfUsers: [], totalCount: 0 };
  }
}
